import React from 'react'
import PropTypes from 'prop-types'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faImage } from '@fortawesome/free-solid-svg-icons'

import { translate } from '../../helpers/stringHelpers'

// components
import LazyImage from '../lazyImage'
import Carousel from '../carousel'
import { Link } from 'react-router-dom'

const ListingMediaImages = ({ images, listingLink, listingUuid, listing }) => {
  if (!images.length) {
    return (
      <div className='ratio--flex-wrapper'>
          <Link to={listingLink}>
            <div className='lot__media--missing'>
              <FontAwesomeIcon icon={faImage} />
              <p><small>{translate('JspPublicCodes_JSP_AWAITING_IMAGE')}</small></p>
            </div>
          </Link>
        </div>
    )
  }
  if (images.length === 1) {
    return (
      <LazyImage
          key={`mainImage${listingUuid}`}
          to={listingLink}
          src={images[0].publicId}
        />
    )
  }
  if (images.length > 1) {
    return (
        <Carousel
          slidesToDisplay={1}
          id={`imagesGallery${listing.lotNumber}`}
          images={images.map(item => ({
            src: item?.publicId,
            label: `${item?.title} - ${listing.title}`,
            to: listingLink
          }))}
          key={`gallery${listing.lotNumber}`}
        />
    )
  }
}

ListingMediaImages.propTypes = {
  images: PropTypes.array.isRequired,
  listingLink: PropTypes.string.isRequired,
  listingUuid: PropTypes.string.isRequired,
  listing: PropTypes.object.isRequired
}

export default React.memo(ListingMediaImages)
